<template>
    <div>

        <div class="columns" v-if="remainingCredits > 0">
            <div class="column"></div>
            <div class="column is-6">

                <div class="app-block p-b-lg p-t-md p-r-lg" >
                    <div class="heading-line title is-4 has-text-weight-light m-l-lg">
                        <span>Avoirs</span>
                    </div>
                    <div class="title is-5 has-text-weight-light has-text-centered">
                        {{ $t('offers.cart.credit') }} <strong class="has-text-weight-bold">{{ order.remainingCredits }} €</strong>
                    </div>
                    <div class="columns">
                        <div class="column is-1"></div>
                        <div class="column is-10 ">
                            <b-field :label="$t('offers.cart.credit_field')"  >
                                <b-numberinput name="credit" v-model="credit" min="0" :max="creditMax">
                                </b-numberinput>
                            </b-field>
                        </div>
                        <div class="column"></div>

                    </div>
                </div>
            </div>
            <div class="column"></div>
        </div>

        <div class="columns" v-if="discountCredits.length > 0">
            <div class="column"></div>
            <div class="column is-6">

                <div class="app-block p-b-lg p-t-md p-r-lg" >
                    <div class="heading-line title is-4 has-text-weight-light m-l-lg">
                        <span>Réductions</span>
                    </div>
                    <div class="p-l-md">
                        <div class="subtitle" v-if="discountCredits.length > 1">
                            Vous disposez des réductions suivantes:
                        </div>
                        <div class="subtitle" v-else>
                            Vous disposez de la réduction suivante:
                        </div>
                        <div v-for="discount in discountCredits" class="p-b-md">
                            <b-checkbox v-model="selectedDiscount" :native-value="discount" @input="discountCheck(discount)" disabled>
                                Réduction de <strong>{{ discount.amount }} €</strong> valable du
                                <strong>{{ formatDate(discount.validity_start) }}</strong>
                                au <strong>{{ formatDate(discount.validity_end) }}</strong>
                            </b-checkbox>
                        </div>
                    </div>

                </div>
            </div>
            <div class="column"></div>
        </div>


        <div v-if="isSchoolingOrder || isSchoolingCheckedOutOrder(order)" class="section">
            <div class="has-background-white-ter p-md has-text-centered">
                <b-checkbox v-model="checkboxContract">
                    <strong>J'accepte le
                        <a :href="schoolContract" target="_blank" :title="$t('candidate.messages.documents.contract')"
                        >
                            {{ $t('candidate.messages.documents.contract') }}</a>
                    </strong>
                </b-checkbox>
            </div>


        </div>
        <div v-else class="section">
            <div class="has-background-white-ter p-md has-text-centered">
                <b-checkbox v-model="checkboxCGE">
                    <strong>J'accepte les
                        <a href="/docs/FR_Conditions_generales_inscription.pdf" target="_blank" :title="$t('shop.messages.documents.cge')"
                        >
                            {{ $t('shop.messages.documents.cge') }}</a>
                    </strong>
                </b-checkbox>
            </div>
        </div>

        <div :class="[!checkboxCGE && !checkboxContract ? 'app-disabled':'']">
            <div class="columns has-text-centered" >

                <div class="column is-3" v-if="!isSchoolingOrder && !isSchoolingCheckedOutOrder(order)">
                    <button @click="toggleCB" type="submit"
                            class="app-block payment-button p-t-md">
                        <div class="is-size-6 has-text-grey is-italic">Carte Bancaire</div>
                        <br>
                        <div class="is-flex is-horizontal-center ">
                            <figure class="image is-48x48">
                                <img src="/img/icons/cards.png">
                            </figure>
                        </div>
                    </button>
                </div>
                <div class="column is-2" v-else>

                </div>

                <div class="column is-3">
                    <button @click="toggleCheck" type="submit"
                            class="app-block payment-button p-t-md">
                        <div class="is-size-6 has-text-grey is-italic">Chèque(s)</div>
                        <div class="is-flex is-horizontal-center ">
                            <figure class="image is-64x64  ">
                                <img src="/img/icons/check.png">
                            </figure>
                        </div>
                    </button>
                </div>

                <!--<div class="column" v-if="isSchoolingOrder || isSchoolingCheckedOutOrder(order)">
                    <button @click="toggleDebit" type="submit"
                            class="app-block payment-button p-t-lg">
                        <div class="is-size-6 has-text-grey is-italic">Prélèvement(s)</div>
                        <br>
                        <div class="is-flex is-horizontal-center ">
                            <figure class="image is-64x64  ">
                                <img src="/img/icons/bank-debit.png">
                            </figure>
                        </div>
                    </button>
                </div>-->


                <div class="column is-3">
                    <button @click="toggleTransfert" type="submit"
                            class="app-block payment-button p-t-md">
                        <div class="is-size-6 has-text-grey is-italic">Virement</div>
                        <br>
                        <div class="is-flex is-horizontal-center ">
                            <figure class="image is-64x64">
                                <i class="fa fa-exchange fa-5x" aria-hidden="true"></i>
                            </figure>
                        </div>
                    </button>
                </div>

              <div class="column is-3">
                <button @click="toggleOrga" type="submit"
                        class="app-block payment-button p-t-md">
                  <div class="is-size-6 has-text-grey is-italic">Organisme de financement</div>
                  <br>
                  <div class="is-flex is-horizontal-center ">
                    <figure class="image is-64x64">
                      <i class="fa fa-institution fa-5x" aria-hidden="true"></i>
                    </figure>
                  </div>
                </button>
              </div>

                <!--<div class="column">
                    <button @click="toggleNote" type="submit"
                            class="app-block payment-button p-t-lg">
                        <div class="is-size-6 has-text-grey is-italic">Espèces</div>
                        <br>
                        <div class="is-flex is-horizontal-center ">
                            <figure class="image is-64x64  ">
                                <img src="/img/icons/bank-note.png">
                            </figure>
                        </div>
                    </button>
                </div>-->

            </div>


            <div id="payment-validation">

                <transition name="component-fade" mode="out-in">
                    <component
                            :is="paymentView"
                            :school="school"
                            :totalCheckout="orderTotalCheckout"
                            :totalSchoolingCheckout="orderTotalSchoolingCheckout"
                            :candidate="candidate"
                            :candidates="candidates"
                            :guarantor="guarantor"
                            :credit="credit"
                            :discount="selectedDiscount"
                            v-on:send="savePayment"
                            v-on:edit="editPayment">
                    </component>
                </transition>
            </div>
        </div>

    </div>

</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import BankOfpView from './OrderOfp.vue'
    import OrderCBView from './OrderCB.vue'
    import CBError from './CBError.vue'
    import OrderSimpleOfpView from './OrderSimpleOfp'
    import OrderDebitNoOfpView from './OrderDebitNoOfp'
    import BankDirectDebitView from './OrderDirectDebit.vue'
    import BankTransferView from './OrderTransfer.vue'
    import BankNoteView from './OrderNote.vue'
    import OrgaView from "./OrderOrga.vue";

    export default {
        data() {
            return {
                paymentView: '',
                checkboxContract: false,
                checkboxCGE: false,
                guarantor: null,
                selectedDiscount: [],
                usedCredit: 0,
                credit: 0
            }
        },
        props: {
            order: { type: Object },
            school: { type: Object },
            candidate: {type: Object},
            candidates: {type: Array}
        },
        computed: {
            ...mapGetters({
                account: 'auth/getAccount'
            }),
            ...mapGetters(
                'orders', [
                    'totalCheckout',
                    'totalSchoolingCheckout',
                    'isSchoolingOrder',
                    'isSchoolingOfferOrder',
                    'isOfferOrder',
                    'selectedOrder',
                    'orderRef',
                    'isSchoolingCheckedOutOrder',
                    'isSchoolingOfferCheckedOutOrder',
                    'isOfferCheckedOutOrder',
                    'status'
                ]
            ),
            ...mapGetters(
                'organization', [
                    'getSchoolBySlug'
                ]
            ),

            schoolContract() {
              if (!this.candidate || !this.candidate.applications) return

              const schoolType = this.candidate.school_type_name
              const schoolName = this.candidate.applications.school_slug

              return '/api/school/contract/'+schoolType+'/'+schoolName
            },

            orderTotalCheckout() {
                let total = 0
                if (this.order && this.order.payment_total) {
                    total = Number(parseFloat(this.order.payment_total).toFixed(2))
                }else{
                    total = this.totalCheckout
                    if (this.selectedDiscount.length) {
                        let totalDiscount = 0
                        this.selectedDiscount.map(function (credit) {
                            totalDiscount += parseInt(credit.amount)
                        })
                        total = total - totalDiscount
                    }
                }


                if (this.credit <= this.remainingCredits) {
                    total = total - this.credit
                }


                return total + this.usedCredit > 0 ? total + this.usedCredit:0
            },
            orderTotalSchoolingCheckout() {
                let total = this.totalSchoolingCheckout

                if (this.credit <= this.remainingCredits) {
                    return total - this.credit
                }

                if (this.order && this.order.credits) {
                    this.order.credits.map(function (credit) {
                        if (credit.type.code === 'credit') {
                            total += parseInt(credit.amount)
                        }
                    }, this)
                }

                /*if (this.selectedDiscount.length) {
                    this.selectedDiscount.map(function (credit) {
                        total += parseInt(credit.amount)
                    })
                }*/

                return total
            },
            remainingCredits() {
                if (this.usedCredit > 0) {
                    return this.account.remainingCredits + this.usedCredit
                }else{
                    return this.account.remainingCredits
                }

            },
            totalPaiement() {
                let total = this.orderTotalCheckout - this.orderTotalSchoolingCheckout
                let totalSchooling = this.totalSchoolingCheckout
                /*if (this.cartDiscount()) {
                    totalSchooling = Math.ceil(totalSchooling - (totalSchooling * 0.05))
                }*/
                return total + totalSchooling
            },
            creditMax() {
                if (this.order.remainingCredits <= this.totalPaiement) {
                    return this.order.remainingCredits
                }else{
                    return this.totalPaiement
                }
            },
            discountCredits() {

                let credits = []
                if (this.order && this.order.discountCredits) {
                    this.order.discountCredits.map(function (credit) {
                        if ((this.isSchoolingOrder || this.isSchoolingCheckedOutOrder(this.order)) && credit.discount_validity.some(discount => discount.code === 'schooling')) {
                            credits.push(credit)
                        }
                        if ((this.isSchoolingOfferOrder || this.isSchoolingOfferCheckedOutOrder(this.order)) && credit.discount_validity.some(discount => discount.code === 'schooling_offer')) {
                            credits.push(credit)
                        }
                        if ((this.isOfferOrder || this.isOfferCheckedOutOrder(this.order)) && credit.discount_validity.some(discount => discount.code === 'offer')) {
                            credits.push(credit)
                        }
                    }, this)
                }
                return credits
            },
        },
        methods: {
            ...mapActions({
                refreshAccount: 'auth/setAccount'
            }),
            ...mapActions(
                'orders', [
                    'fetchCBCheckout'
                ]
            ),
            formatDate(date) {
                return moment(date, 'YYYY-MM-DD hh:mm:ss').format('L')
            },
            discountCheck(discount) {
                if (this.order && !this.selectedDiscount.some(d => d.id === discount.id)) {
                    this.usedCredit += parseInt(discount.amount)
                }else {
                    this.usedCredit -= parseInt(discount.amount)
                }
            },
            toggleCB () {
                this.errorShow = false
                let order = {
                    order_id: this.orderRef,
                    credit: this.credit
                }
                this.fetchCBCheckout(order).then((result) => {
                    this.paymentView = OrderCBView
                    this.$scrollTo('#payment-validation', {offset: -250}, 500)
                }).catch((err) => {
                    this.error = err.message
                })
            },
            toggleCheck() {
                this.errorShow = false
                if (this.isSchoolingOrder || this.isSchoolingCheckedOutOrder(this.order)) {
                    this.paymentView = BankOfpView
                }else{
                    this.paymentView = OrderSimpleOfpView
                }

                this.$scrollTo('#payment-validation', {offset: -250}, 500)
            },
            toggleTransfert() {
                this.errorShow = false
                this.paymentView = BankTransferView
                this.$scrollTo('#payment-validation', {offset: -250}, 500)
            },
          toggleOrga() {
            this.errorShow = false;
            this.paymentView = OrgaView;
            this.$scrollTo('#payment-validation', {offset: -250}, 500)
          },
            toggleDebit() {
                this.errorShow = false
                if (this.isSchoolingOrder || this.isSchoolingCheckedOutOrder(this.order)) {
                    this.paymentView = BankDirectDebitView
                }else{
                    this.paymentView = OrderDebitNoOfpView
                }

                this.$scrollTo('#payment-validation', {offset: -250}, 500)
            },
            toggleNote() {
                this.errorShow = false
                this.paymentView = BankNoteView
                this.$scrollTo('#payment-validation', {offset: -250}, 500)
            },
            savePayment() {
                this.refreshAccount()
                this.$emit('send')
            },
            editPayment() {
                this.$emit('edit')
            },
        },
        created() {

            if (this.order && this.order.credits) {
                this.order.credits.map(function (credit) {
                    if (credit.type.code === 'credit') {
                        this.credit += parseInt(credit.amount)
                        this.usedCredit += parseInt(credit.amount)
                    }
                }, this)


                this.order.credits.map(function (credit) {
                    if (credit.type.code === 'discount' && this.order.discountCredits) {
                        let selected = credit.credit_id
                        this.order.discountCredits.map(function (credit) {
                            if (credit.id === selected) {
                                this.selectedDiscount.push(credit)
                            }
                        }, this)

                    }
                }, this)
            }
        }
    }
</script>

<style scoped>

</style>
